import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

/**
 * Reusable scroll-reveal wrapper. Fades + slides content in once it enters
 * the viewport, using the same framer-motion + react-intersection-observer
 * pattern already used across the site's animated sections.
 */
const DIRECTION_OFFSETS = {
  up: { y: 24, x: 0 },
  down: { y: -24, x: 0 },
  left: { y: 0, x: 24 },
  right: { y: 0, x: -24 },
  none: { y: 0, x: 0 },
};

const Reveal = ({
  children,
  direction = 'up',
  delay = 0,
  duration = 0.6,
  threshold = 0.15,
  once = true,
  as: Component = motion.div,
  className,
  style,
}) => {
  const [ref, inView] = useInView({ threshold, triggerOnce: once });
  const offset = DIRECTION_OFFSETS[direction] || DIRECTION_OFFSETS.up;

  return (
    <Component
      ref={ref}
      className={className}
      style={style}
      initial={{ opacity: 0, x: offset.x, y: offset.y }}
      animate={inView ? { opacity: 1, x: 0, y: 0 } : { opacity: 0, x: offset.x, y: offset.y }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Component>
  );
};

export default Reveal;
